import { and, asc, eq } from "drizzle-orm";
import {
  menu_category,
  menu_product,
  modifier_group,
  modifier_option,
  type PowerSyncDrizzleDB,
  product_modifier_group,
} from "@comandero/powersync";
import {
  liveMenuCategoryFilters,
  liveMenuProductFilters,
  liveModifierGroupFilters,
  liveModifierOptionFilters,
  liveProductModifierGroupFilters,
} from "../live/filters";

export function getCategoriesQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(menu_category)
    .where(and(eq(menu_category.organization_id, organizationId), ...liveMenuCategoryFilters()))
    .orderBy(asc(menu_category.sort_order), asc(menu_category.name));
}

export function getProductsQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(menu_product)
    .where(and(eq(menu_product.organization_id, organizationId), ...liveMenuProductFilters()))
    .orderBy(asc(menu_product.name));
}

export function getProductsByCategoryQuery(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  categoryId: string,
) {
  return db
    .select()
    .from(menu_product)
    .where(
      and(
        eq(menu_product.organization_id, organizationId),
        eq(menu_product.category_id, categoryId),
        ...liveMenuProductFilters(),
      ),
    )
    .orderBy(asc(menu_product.name));
}

export function getModifierGroupsQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(modifier_group)
    .where(and(eq(modifier_group.organization_id, organizationId), ...liveModifierGroupFilters()))
    .orderBy(asc(modifier_group.sort_order), asc(modifier_group.name));
}

export function getModifierOptionsQuery(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  modifierGroupId: string,
) {
  return db
    .select()
    .from(modifier_option)
    .where(
      and(
        eq(modifier_option.organization_id, organizationId),
        eq(modifier_option.modifier_group_id, modifierGroupId),
        ...liveModifierOptionFilters(),
      ),
    )
    .orderBy(asc(modifier_option.sort_order), asc(modifier_option.name));
}

export function getProductModifierGroupsQuery(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  productId: string,
) {
  return db
    .select()
    .from(product_modifier_group)
    .where(
      and(
        eq(product_modifier_group.organization_id, organizationId),
        eq(product_modifier_group.product_id, productId),
        ...liveProductModifierGroupFilters(),
      ),
    );
}
